<template>
  <header class="c-header">
    <div class="c-header__logo">
      <a href="/"><img :src="`${assets_path}img/common/logo.svg`" alt="I LADY" width="191" height="58"></a>
    </div>

    <div class="c-header__btn" @click="openNav">
      <transition name="c-trigger">
      <div v-show="!$store.getters.isShowGnav" class="c-trigger">
        <div class="c-trigger__wrap">
          <span></span>
          <span></span>
        </div>
      </div>
      </transition>
    </div>
  </header>
</template>

<script>
  import { breakpoint, assets_path } from '@/_modules/utils/variables'
  import store from '@/_modules/stores';

  export default {
    data() {
      return {
        assets_path: assets_path
      }
    },
    store,
    created() {},
    mounted() {
    },
    methods: {
      openNav() {
        this.$store.commit('setShowGnav', true);
      }
    }
  }
</script>
